import { useQuery } from '@apollo/client'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import { FIND_ALL_STUDY_GUIDE } from 'queries/studyGuide'
import { findAllStudyGuide, findAllStudyGuideVariables } from '__generatedTypes__/findAllStudyGuide'
import { SelectItem } from 'pagesNew/SuccessStory/Create/SimilarPosts'
import { getPostsValue } from 'pagesNew/SuccessStory/Create/hooks'

type UseGetAllSuccessStoriesReturn = {
  loading: boolean
  getInitialValue: (selected: SelectItem[]) => SelectItem[]
}

export const useGetSimilarPostsInitialValue = (
  platformId: string,
  isEditing = false
): UseGetAllSuccessStoriesReturn => {
  const { data, loading } = useQuery<findAllStudyGuide, findAllStudyGuideVariables>(FIND_ALL_STUDY_GUIDE, {
    variables: {
      query: {
        take: TAKE_ALL_ITEMS_COUNT,
        where: {
          platform: {
            id: platformId,
          },
        },
      },
    },
  })

  const studyGuides = data?.findAllStudyGuide?.items || []

  const getInitialValue = (selectedPosts: SelectItem[]) => {
    const studyGuidesCount = studyGuides.length
    const selectedPostsLength = selectedPosts?.length || 0

    return getPostsValue(selectedPosts, isEditing ? studyGuidesCount - 1 : studyGuidesCount, selectedPostsLength)
  }

  return { loading, getInitialValue }
}
